// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 47 ? "client" : chunkId) + "." + {"47":"170b9423","787":"b205a35b"}[chunkId] + ".chunk.js";
};